import H5VideoTemplate from '../../../component/template/H5VideoTemplate'
import SimpleBanner from "../../../component/visible/SimpleBanner"
import SingleVideoRewardManager from '../../../component/visible/SingleVideoRewardManager/SingleVideoRewardManager'
import App from '../../../App'
import Message from '../../../Message'
import CountdownButton from '../../../component/visible/CountdownButton'
import MuteSwitchableButton from '../../../component/visible/MuteSwitchableButton'
import { onScreenClick } from '../../../../common/report'

class Tpl1 extends H5VideoTemplate{
    constructor(...props) {
        super(...props)
    }

    adShowed(data) {
        super.adShowed()
        console.log(data)
        this.windowStartPoint = data && data.param || {}
        this.platform.getDevMuteSetting(data).then((mutedSetting) => {
            const newMutedStatus = mutedSetting == 1 ? true : false
            if (newMutedStatus != this.playerView.isMute()) {
                this.playerView.toggleMute()
                this.volumeBtn.changeMountedBtn(newMutedStatus)
            }
        })
    }

    /**
     * 初始化
     * @return
     */
    init() {
        // 调用父类通用的init方法，处理初始化操作
        super.init()

        // 添加自身特有的初始化操作
        console.log('具体实现')
    }

    initComponents() {
        super.initComponents()
        // cta banner组件初始化 - START
        this.banner = new SimpleBanner({
            icon: this.campaign.icon_url,
            buttonText: this.campaign.ctatext,
            title: this.campaign.title,
            star: this.campaign.rating,
            rating: this.campaign.rating,
            desc: this.campaign.desc,
            theme: 'black',
            onButtonClick: (e) => {
              this.install(e)
            },
        })
        this.banner.appendTo(document.querySelector('#banner-container'))
        // cta banner组件初始化 - END

        // H5 Video组件初始化 - START
        // Video组件挂载
        this.playerView.appendTo(document.querySelector('#video-container'));
        // H5 Video组件初始化 - END

        // IV/RV弹窗、关闭按钮组件初始化 - START
        SingleVideoRewardManager.init({
            ad_type: this.campaign.ad_type,
            appSetting: App.initData.appSetting,
            unitSetting: App.initData.unitSetting,
            videoElement: this.playerView.getInstance().querySelector('video'),
            currentCampaign: this.campaign,
            closeTplFunc: () => this.closeTpl(),
            onDialogShow: () => this.onPopupShow(),
            onDialogHide: () => this.onPopupHide(),
        })
        // IV/RV弹窗组件初始化 - END

        // 倒计时按钮初始化 - START
        this.countdownBtn = new CountdownButton()
        this.countdownBtn.countdown = this.campaign.video_length
        this.countdownBtn.appendTo(document.body)
        // 倒计时按钮初始化 - END

        // 静音/非静音按钮初始化 - START
        this.volumeBtn = new MuteSwitchableButton({
            muted: this.playerView.isMute(),
            onClick: (e) => {
                this.playerView.toggleMute()
                const sendData = {
                    instanceId: App.rootWebviewId,
                    campaign: this.campaign,
                    muted: this.playerView.isMute(),
                }
                Message.emitMessageToSuperView('onMuteBtnClick', sendData)
            }
        })
        this.volumeBtn.appendTo(document.querySelector('#mute-button-container'))
        // 静音/非静音按钮初始化 - END
    }
    
    /**
     * 绑定事件
     * @return
     */
    bindEvent(){
        super.bindEvent()
        this.playerView.onVideoTimeUpdateWithSecondAccu(() => {
            this.countdownBtn.countdown = Math.floor(this.playerView.getVideoAttribute('duration') - this.playerView.getVideoAttribute('currentTime'))
            const sendData = {
                instanceId: App.rootWebviewId,
                currentTime: this.playerView.getVideoAttribute('currentTime'),
                videoPercentage: (this.playerView.getVideoAttribute('currentTime') / this.playerView.getVideoAttribute('duration')).toFixed(2),
                campaign: this.campaign,
            }
            Message.emitMessageToSuperView('onVideoCurrentTimeChange', sendData)
        })
        this.playerView.bindVideoEvent('ended', () => {
            const sendData = {
                instanceId: App.rootWebviewId,
                campaign: this.campaign,
            }
            Message.emitMessageToSuperView('onVideoEnded', sendData)
        })
        this.playerView.bindVideoEvent('click', () => {
            const sendData = {
                instanceId: App.rootWebviewId,
                campaign: this.campaign,
                hasShown: this.banner.hasShown,
            }
            Message.emitMessageToSuperView('onTplClick', sendData)
        })
    }

    bindPageEvent() {
        this.platform.onAdShow((data) => {
            if (data.playVideoMute == 1 && this.playerView.isUnmute()) {
                this.playerView.mute()
                this.volumeBtn.changeMountedBtn(true)
            } else if(this.playerView.isMute()) {
                this.playerView.unmute()
                this.volumeBtn.changeMountedBtn(false)
            }
        })
        Message.onSuperViewEmitMessage('pausePlay', () => this.playerView.pause())
        Message.onSuperViewEmitMessage('resumePlay', () => this.playerView.play())
        Message.onSuperViewEmitMessage('hideCtaBanner', () => {
            this.banner.hide()
            document.querySelector('#mute-button-container').style.bottom = (10/75/2) + 'rem'
        })
        Message.onSuperViewEmitMessage('showCtaBanner', () => {
            this.banner.show()
            document.querySelector('#mute-button-container').style.bottom = (190/75/2) + 'rem'
        })
    }

    /**
     * 安装
     * @param any
     */
    //@report([])
    install(event) {
        onScreenClick.call(
            this,
            event,
            {
                autoClick: false,
                template: 'rv',
                ctabanner: true,
                campaign: this.campaign,
            }
        )
        const sendData = {
            instanceId: App.rootWebviewId,
            campaign: this.campaign,
            clickEvent: {
                pageX: event.pageX,
                clientX: event.clientX,
                pageY: event.pageY,
                clientY: event.clientY,
            },
        }

        Message.emitMessageToSuperView('onInstallBtnClick', sendData)
    }

    // 工具方法，传入组件进行事件绑定 -- START
    // IV/RV弹窗用户选择退出
    closeTpl() {
        const sendData = {
            instanceId: App.rootWebviewId,
            campaign: this.campaign,
        }
        Message.emitMessageToSuperView('onCloseBtnClick', sendData)
    }

    // IV/RV弹窗显示
    onPopupShow() {
        Message.emitMessageToSuperView('popupShow')
    }

    // IV/RV弹窗隐藏 when 用户选择继续观看视频
    onPopupHide() {
        Message.emitMessageToSuperView('popupHide')
    }

    // 工具方法 -- END

    destory() {
        super.destory()
        this.banner && this.banner.destory()
        this.countdownBtn && this.countdownBtn.destory()
        this.volumeBtn && this.volumeBtn.destory()
    }

    _isLoadFinish() {
        const promise = super._isLoadFinish()
        promise.then(() => {
            console.log('tpl1 load 成功')
        }).catch(e=>{
            console.log('tpl1 load 失败', e)
        })
        return promise
    }
}

export default Tpl1